import * as Actions from './SessionAttendeesActions';

const initialState = {
  fetching: false,
  attendees: [],
  page: {
    size: 0,
    totalElements: 0,
    totalPages: 0,
    number: 0
  },
  error: null,
  filter: {
    textSearch: ''
  },
  sort: {
    sortBy: null,
    sortOrder: null
  }
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.GET_SESSION_ATTENDEES_REQUEST: {
      return { ...state, fetching: true };
    }
    case Actions.GET_SESSION_ATTENDEES_SUCCESS: {
      const { attendees, filter, page, sort } = action.payload;
      return {
        ...state,
        attendees,
        page,
        filter,
        sort,
        fetching: false
      };
    }
    case Actions.GET_SESSION_ATTENDEES_FAILURE: {
      return { ...state, ...initialState, error: action.error, fetching: false };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Reducks/SessionAttendees/SessionAttendeesReducer.js